export function coerceError(maybeError: unknown) {
    if (maybeError instanceof Error) {
        return maybeError;
    }

    const msg = typeof maybeError === 'string' ? maybeError : JSON.stringify(maybeError);

    return new Error(msg);
}
